import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { PeriodicReportConfigRequest } from 'src/app/models/turns-models/periodic-report.model';

@Injectable({ providedIn: 'root' })
export class PeriodicReportsTurnsDaoService {
  private readonly baseUrl = environment.apiURL + 'private/v2.0/mturnReports/';

  constructor(private http: HttpClient) { }

  private options(context: string, lang: string, udid: string) {
    return { headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8',
      context, lang, udid
    }) };
  }

  public configs(context: string, lang: string, udid: string) {
    return this.http.get<any>(this.baseUrl + 'configs', this.options(context, lang, udid));
  }

  public generated(context: string, lang: string, udid: string) {
    return this.http.get<any>(this.baseUrl + 'generated', this.options(context, lang, udid));
  }

  public detail(context: string, lang: string, udid: string, internalId: string) {
    return this.http.post<any>(this.baseUrl + 'config/detail', { internalId }, this.options(context, lang, udid));
  }

  public save(context: string, lang: string, udid: string, request: PeriodicReportConfigRequest) {
    const endpoint = request.internalId ? 'config/update' : 'config/create';
    return this.http.post<any>(this.baseUrl + endpoint, request, this.options(context, lang, udid));
  }

  public active(context: string, lang: string, udid: string, internalId: string, active: boolean) {
    return this.http.post<any>(this.baseUrl + 'config/active', { internalId, active }, this.options(context, lang, udid));
  }

  public deleteConfig(context: string, lang: string, udid: string, internalId: string) {
    return this.http.post<any>(this.baseUrl + 'config/delete', { internalId }, this.options(context, lang, udid));
  }

  public generate(context: string, lang: string, udid: string, internalId: string) {
    return this.http.post<any>(this.baseUrl + 'generate', { internalId }, this.options(context, lang, udid));
  }
}
